(function () {
  var activeModal = null;
  var activeDialog = null;
  var lastFocusedElement = null;

  var CHARTS = {
    'premium-oversize': {
      title: 'Oversize Tişört Ölçü Tablosu',
      category: 'Tişört',
      fitLabel: 'Oversize',
      fitText: 'Bu ürün oversize kalıptadır. Daha salaş ve rahat bir görünüm için tasarlanmıştır.',
      diagram: 'top',
      columns: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
      rows: [
        ['Göğüs (A)', '54', '56', '58', '60', '62,5', '65,5'],
        ['Etek (B)', '51,5', '53,5', '55,5', '57,5', '60', '63'],
        ['Omuzdan Omuza (C)', '53', '55', '57', '59', '61', '63'],
        ['Omuzdan Boy (D)', '71', '72', '73', '74', '75,5', '77'],
        ['Kol Boyu (E)', '20', '21', '22', '23', '24', '25']
      ],
      tip: 'Tişörtler oversize kalıptadır. Daha dengeli görünüm için normal bedenini, ekstra bol görünüm için bir büyük bedeni tercih edebilirsin.'
    },

    'cift-kollu-sweatshirt': {
      title: 'Çift Kollu Tişört Ölçü Tablosu',
      category: 'Çift Kollu Tişört',
      fitLabel: 'Oversize',
      fitText: 'Bu model rahat ve hacimli duruş için oversize kalıpta hazırlanmıştır.',
      diagram: 'top',
      columns: ['S', 'M', 'L', 'XL'],
      rows: [
        ['Göğüs (A)', '55', '57', '59', '61'],
        ['Etek (B)', '53', '55', '57', '59,5'],
        ['Omuzdan Omuza (C)', '55', '57', '59', '61'],
        ['Omuzdan Boy (D)', '72', '73,5', '75', '77'],
        ['Kol Boyu (E)', '52', '53', '54', '55']
      ],
      tip: 'İki beden arasında kalıyorsan, daha rahat kullanım için büyük bedeni tercih edebilirsin.'
    },

    'sweatshirt': {
      title: 'Sweatshirt Ölçü Tablosu',
      category: 'Sweatshirt',
      fitLabel: 'Normal Fit',
      fitText: 'Bu ürün normal kalıptadır. Günlük kullanım için dengeli bir duruş sunar.',
      diagram: 'top',
      columns: ['S', 'M', 'L', 'XL', 'XXL'],
      rows: [
        ['Göğüs (A)', '58', '60', '62', '64', '67'],
        ['Etek (B)', '42', '44', '46', '48', '51'],
        ['Omuzdan Omuza (C)', '49,5', '51', '52,5', '54', '55,5'],
        ['Omuzdan Boy (D)', '69,5', '71', '72,5', '74', '76'],
        ['Kol Boyu (E)', '60,5', '61,5', '62,5', '63,5', '64,5']
      ],
      tip: 'Normal kalıp ürünlerde günlük kullanım için kendi bedenini tercih etmen önerilir.'
    },

    'fermuarli-sweatshirt': {
      title: 'Fermuarlı Sweatshirt Ölçü Tablosu',
      category: 'Fermuarlı Sweatshirt',
      fitLabel: 'Normal Fit',
      fitText: 'Bu ürün normal kalıptadır. Fermuarlı yapısı sayesinde katmanlı kullanım için uygundur.',
      diagram: 'top',
      columns: ['S', 'M', 'L', 'XL', 'XXL'],
      rows: [
        ['Göğüs (A)', '58', '60', '62', '65', '68'],
        ['Etek (B)', '42', '44', '47', '50', '53'],
        ['Omuzdan Omuza (C)', '49', '51', '53', '55', '57'],
        ['Omuzdan Boy (D)', '72', '73', '74', '75', '76,5'],
        ['Kol Boyu (E)', '60', '61', '62', '63', '64']
      ],
      tip: 'İçine tişört veya ince sweatshirt ile kullanacaksan, rahatlık için bir büyük beden tercih edebilirsin.'
    },

    'erkek-jogger': {
      title: 'Eşofman Altı Ölçü Tablosu',
      category: 'Eşofman Altı',
      fitLabel: 'Normal Fit',
      fitText: 'Bu ürün normal kalıptadır. Bel lastiği esnek yapıda olsa da ölçüler lastik esnetilmeden alınmıştır.',
      diagram: 'bottom',
      columns: ['S', 'M', 'L', 'XL', 'XXL'],
      rows: [
        ['Bel Durgun (A)', '36', '38', '40', '43', '46'],
        ['Basen (B)', '53', '55', '57', '60', '63'],
        ['Baldır (C)', '31', '33', '35', '38', '41'],
        ['Yan Boy Kemer Dahil (D)', '102', '103', '104', '105,5', '107']
      ],
      tip: 'Bel ölçüsü ürün düz zemindeyken ve lastik esnetilmeden alınmıştır. Daha rahat kullanım için basen ölçüsünü de kontrol etmeni öneririz.'
    },

    'sort': {
      title: 'Şort Ölçü Tablosu',
      category: 'Şort',
      fitLabel: 'Normal Fit',
      fitText: 'Bu ürün normal kalıptadır. Ölçüler ürün düz zemine serilerek alınmıştır.',
      diagram: 'bottom',
      columns: ['S', 'M', 'L', 'XL', 'XXL'],
      rows: [
        ['Bel (A)', '35', '37', '39', '42', '45'],
        ['Basen (B)', '51', '53', '55', '57', '60'],
        ['Paça (C)', '29', '29,5', '30', '30,5', '31'],
        ['Boy (D)', '49', '50', '51', '52', '53']
      ],
      tip: 'Şortlarda rahat kullanım için bel ve basen ölçüsünü birlikte kontrol etmeni öneririz.'
    },

    'yelek': {
      title: 'Yelek Ölçü Tablosu',
      category: 'Yelek',
      fitLabel: 'Normal Fit',
      fitText: 'Bu ürün normal kalıptadır. Kolsuz yapısı sayesinde göğüs ve etek ölçüsü seçimde daha belirleyicidir.',
      diagram: 'vest',
      columns: ['S', 'M', 'L', 'XL', 'XXL'],
      rows: [
        ['Göğüs (A)', '48', '50', '52', '55', '58'],
        ['Etek (B)', '55', '57', '59', '62', '65'],
        ['Omuzdan Omuza (C)', '53', '54', '55', '56', '57'],
        ['Omuzdan Boy (D)', '59', '60', '61', '62', '63']
      ],
      tip: 'Yeleklerde içe giyilecek parçayı düşünerek göğüs ölçüsünü kontrol etmeni öneririz.'
    },

    'kadin-crop-tshirt': {
      title: 'Crop T-Shirt Ölçü Tablosu',
      category: 'Crop T-Shirt',
      fitLabel: 'Normal Fit',
      fitText: 'Bu ürün crop formdadır. Kısa boylu modern bir duruş için tasarlanmıştır.',
      diagram: 'top',
      columns: ['S', 'M', 'L', 'XL', 'XXL'],
      rows: [
        ['Göğüs (A)', '46', '48', '50', '53', '56'],
        ['Etek (B)', '45', '47', '49', '52', '55'],
        ['Omuzdan Omuza (C)', '41', '43', '45', '47', '49'],
        ['Omuzdan Boy (D)', '42', '43', '44', '45', '46'],
        ['Kol Boyu (E)', '19,5', '20', '20,5', '21', '21,5']
      ],
      tip: 'Crop ürünlerde ürün boyu kısa olduğu için “Omuzdan Boy” ölçüsünü mutlaka kontrol etmeni öneririz.'
    },

    'erkek-buyuk-beden': {
      title: 'Erkek Büyük Beden Ölçü Tablosu',
      category: 'Erkek Büyük Beden Tişört',
      fitLabel: 'Büyük Beden',
      fitText: 'Bu ürün büyük beden kalıbına göre hazırlanmıştır. Ölçüler ürün ölçüsüdür.',
      diagram: 'top',
      columns: ['3XL - 48', '4XL - 50', '5XL - 52', '6XL - 54'],
      rows: [
        ['Göğüs (A)', '70', '73', '76', '79'],
        ['Etek (B)', '68', '71', '74', '77'],
        ['Omuzdan Omuza (C)', '67', '70', '73', '76'],
        ['Omuzdan Boy (D)', '82', '83,5', '85', '86,5'],
        ['Kol Boyu (E)', '26', '27', '28', '29']
      ],
      tip: 'Büyük beden ürünlerde göğüs ve etek ölçüsünü birlikte kontrol etmek daha doğru seçim sağlar.'
    },

    'kadin-buyuk-beden': {
      title: 'Kadın Büyük Beden Ölçü Tablosu',
      category: 'Kadın Büyük Beden Tişört',
      fitLabel: 'Büyük Beden',
      fitText: 'Bu ürün büyük beden kalıbına göre hazırlanmıştır. Ölçüler ürün ölçüsüdür.',
      diagram: 'top',
      columns: ['3XL - 48', '4XL - 50', '5XL - 52', '6XL - 54'],
      rows: [
        ['Göğüs (A)', '67', '70', '73', '76'],
        ['Etek (B)', '65', '68', '71', '74'],
        ['Omuzdan Omuza (C)', '64', '67', '70', '73'],
        ['Omuzdan Boy (D)', '80', '81,5', '83', '84,5'],
        ['Kol Boyu (E)', '24', '25', '26', '27']
      ],
      tip: 'Büyük beden ürünlerde rahat kullanım için göğüs, etek ve ürün boyu ölçülerini birlikte kontrol etmeni öneririz.'
    }
  };

  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function escapeHTML(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function getMeasurements(type) {
    if (type === 'bottom') {
      return [
        ['A', 'Bel', 'Ürünün bel kısmındaki düz genişlik ölçüsüdür.', 'Bel lastiği esnetilmeden, ürün düz zeminde yan dikişten yan dikişe ölçülür.'],
        ['B', 'Basen', 'Ürünün kalça/basen hizasındaki en geniş düz ölçüsüdür.', 'Ürün düz zeminde seriliyken en geniş noktadan yatay ölçüm alınır.'],
        ['C', 'Baldır / Paça', 'Ürünün paça veya baldır bölgesindeki yatay genişlik ölçüsüdür.', 'Model tipine göre paça ağzı ya da baldır hizası yatay şekilde ölçülür.'],
        ['D', 'Yan Boy', 'Ürünün bel üst noktasından paça ucuna kadar olan toplam uzunluğudur.', 'Mezura yan dikiş hattı boyunca düz şekilde tutulur.']
      ];
    }

    if (type === 'vest') {
      return [
        ['A', 'Göğüs', 'Ürünün göğüs hizasında, koltuk altından koltuk altına olan düz genişlik ölçüsüdür.', 'Ürün düz zemine serilir ve göğüs hattından yatay ölçüm alınır.'],
        ['B', 'Etek', 'Ürünün etek ucundaki düz genişlik ölçüsüdür.', 'Etek ucunda yan dikişten yan dikişe yatay ölçülür.'],
        ['C', 'Omuzdan Omuza', 'Ürünün iki omuz noktası arasındaki düz genişlik ölçüsüdür.', 'Bir omuz dikişinden diğer omuz dikişine yatay ölçülür.'],
        ['D', 'Omuzdan Boy', 'Ürünün omuz tepe noktasından etek ucuna kadar olan toplam uzunluğudur.', 'Mezura omuz noktasından aşağı doğru dik şekilde tutulur.']
      ];
    }

    return [
      ['A', 'Göğüs', 'Ürünün göğüs hizasında, koltuk altından koltuk altına olan düz genişlik ölçüsüdür.', 'Ürün düz zemine serilir ve koltuk altı hizasından yatay ölçüm alınır.'],
      ['B', 'Etek', 'Ürünün etek ucundaki düz genişlik ölçüsüdür.', 'Etek ucunda yan dikişten yan dikişe yatay ölçülür.'],
      ['C', 'Omuzdan Omuza', 'Ürünün iki omuz noktası arasındaki düz genişlik ölçüsüdür.', 'Bir omuz dikişinden diğer omuz dikişine yatay ölçülür.'],
      ['D', 'Omuzdan Boy', 'Ürünün omuz tepe noktasından etek ucuna kadar olan toplam uzunluğudur.', 'Mezura omuz noktasından aşağı doğru dik şekilde tutulur.'],
      ['E', 'Kol Boyu', 'Ürünün omuz dikişinden kol ucuna kadar olan uzunluğudur.', 'Omuz dikişinden kol ağzına kadar mezura düz şekilde tutulur.']
    ];
  }

  function getSvg(type) {
    if (type === 'bottom') {
      return `
        <svg class="ep-size-illustration" viewBox="0 0 420 420" role="img">
          <path class="ep-ill-outline" d="M135 55 H285 L305 360 H235 L210 145 L185 360 H115 Z" />
          <path class="ep-ill-detail" d="M135 88 H285 M210 55 V145 M185 360 H115 M235 360 H305" />
          <line class="ep-ill-measure" x1="135" y1="38" x2="285" y2="38" />
          <text class="ep-ill-label" x="210" y="28">A</text>
          <line class="ep-ill-measure" x1="120" y1="145" x2="300" y2="145" />
          <text class="ep-ill-label" x="310" y="152">B</text>
          <line class="ep-ill-measure" x1="215" y1="275" x2="295" y2="275" />
          <text class="ep-ill-label" x="305" y="282">C</text>
          <line class="ep-ill-measure" x1="82" y1="55" x2="82" y2="360" />
          <text class="ep-ill-label" x="58" y="214">D</text>
        </svg>
      `;
    }

    if (type === 'vest') {
      return `
        <svg class="ep-size-illustration" viewBox="0 0 420 420" role="img">
          <path class="ep-ill-outline" d="M155 65 C175 85 245 85 265 65 L315 128 C292 160 288 195 292 350 H128 C132 195 128 160 105 128 Z" />
          <path class="ep-ill-detail" d="M178 76 C184 110 236 110 242 76 M210 98 V350 M128 350 H292" />
          <line class="ep-ill-measure" x1="128" y1="185" x2="292" y2="185" />
          <text class="ep-ill-label" x="210" y="173">A</text>
          <line class="ep-ill-measure" x1="128" y1="365" x2="292" y2="365" />
          <text class="ep-ill-label" x="210" y="392">B</text>
          <line class="ep-ill-measure" x1="115" y1="112" x2="305" y2="112" />
          <text class="ep-ill-label" x="210" y="101">C</text>
          <line class="ep-ill-measure" x1="82" y1="65" x2="82" y2="350" />
          <text class="ep-ill-label" x="58" y="214">D</text>
        </svg>
      `;
    }

    return `
      <svg class="ep-size-illustration" viewBox="0 0 420 420" role="img">
        <path class="ep-ill-outline" d="M150 78 C175 98 245 98 270 78 L335 120 L310 205 L286 196 L292 350 H128 L134 196 L110 205 L85 120 Z" />
        <path class="ep-ill-detail" d="M172 82 C180 118 240 118 248 82 M128 350 H292 M134 196 V350 M286 196 V350" />
        <line class="ep-ill-measure" x1="134" y1="184" x2="286" y2="184" />
        <text class="ep-ill-label" x="210" y="171">A</text>
        <line class="ep-ill-measure" x1="128" y1="365" x2="292" y2="365" />
        <text class="ep-ill-label" x="210" y="392">B</text>
        <line class="ep-ill-measure" x1="95" y1="112" x2="325" y2="112" />
        <text class="ep-ill-label" x="300" y="101">C</text>
        <line class="ep-ill-measure" x1="62" y1="78" x2="62" y2="350" />
        <text class="ep-ill-label" x="38" y="214">D</text>
        <line class="ep-ill-measure" x1="330" y1="120" x2="308" y2="205" />
        <text class="ep-ill-label" x="346" y="166">E</text>
      </svg>
    `;
  }

  function renderTable(chart) {
    var thead = chart.columns.map(function (column) {
      return '<th scope="col">' + escapeHTML(column) + '</th>';
    }).join('');

    var tbody = chart.rows.map(function (row) {
      var cells = row.slice(1).map(function (cell) {
        return '<td>' + escapeHTML(cell) + '</td>';
      }).join('');

      return '<tr><th scope="row">' + escapeHTML(row[0]) + '</th>' + cells + '</tr>';
    }).join('');

    return `
      <table class="ep-size-table">
        <caption>${escapeHTML(chart.title)} - ölçüler santimetre cinsindendir.</caption>
        <thead>
          <tr>
            <th scope="col">Ölçüm Yeri</th>
            ${thead}
          </tr>
        </thead>
        <tbody>${tbody}</tbody>
      </table>
    `;
  }

  function renderMeasurements(type) {
    return getMeasurements(type).map(function (item) {
      return `
        <div class="ep-size-measurements__item">
          <div class="ep-size-measurements__key">${escapeHTML(item[0])}</div>
          <div>
            <strong>${escapeHTML(item[1])}</strong>
            <p>${escapeHTML(item[2])}</p>
            <small>${escapeHTML(item[3])}</small>
          </div>
        </div>
      `;
    }).join('');
  }

  function applyChart(modal, handle) {
    if (!modal) return;

    var chart = CHARTS[handle] || CHARTS['premium-oversize'];

    modal.dataset.epCurrentChart = handle;

    var title = modal.querySelector('.ep-size-modal__title');
    var fitBadge = modal.querySelector('.ep-size-modal__badges span:first-child');
    var intro = modal.querySelector('.ep-size-modal__intro');
    var currentCategory = modal.querySelector('[data-ep-size-current-category]');
    var visual = modal.querySelector('.ep-size-modal__visual');
    var tableWrap = modal.querySelector('.ep-size-table-wrap');
    var tip = modal.querySelector('.ep-size-guide__card--highlight p');
    var measurements = modal.querySelector('.ep-size-measurements');

    if (title) title.textContent = chart.title;
    if (fitBadge) fitBadge.textContent = chart.fitLabel;
    if (intro) intro.textContent = chart.fitText;
    if (currentCategory) currentCategory.textContent = chart.category;
    if (visual) visual.innerHTML = getSvg(chart.diagram);
    if (tableWrap) tableWrap.innerHTML = renderTable(chart);
    if (tip) tip.textContent = chart.tip;
    if (measurements) measurements.innerHTML = renderMeasurements(chart.diagram);

    modal.querySelectorAll('[data-ep-chart-select]').forEach(function (button) {
      button.classList.toggle('is-active', button.getAttribute('data-ep-chart-select') === handle);
    });
  }

  function getFocusableElements(container) {
    if (!container) return [];

    return Array.prototype.slice.call(container.querySelectorAll(focusableSelector)).filter(function (element) {
      return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
    });
  }

  function lockPage() {
    document.documentElement.classList.add('ep-size-lock');
  }

  function unlockPageIfNeeded() {
    var openModals = document.querySelectorAll('[data-ep-size-modal].is-open');

    if (!openModals.length) {
      document.documentElement.classList.remove('ep-size-lock');
    }
  }

  function moveModalsToBody(scope) {
    var root = scope || document;
    var modals = root.querySelectorAll('[data-ep-size-modal]');

    modals.forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function openModalById(modalId) {
    if (!modalId) return;

    var modal = document.getElementById(modalId);
    if (!modal) return;

    var dialog = modal.querySelector('.ep-size-modal__dialog');
    if (!dialog) return;

    lastFocusedElement = document.activeElement;

    applyChart(modal, modal.dataset.epCurrentChart || 'premium-oversize');

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    activeModal = modal;
    activeDialog = dialog;

    lockPage();

    window.setTimeout(function () {
      dialog.focus();
    }, 30);
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    if (activeModal === modal) {
      activeModal = null;
      activeDialog = null;
    }

    unlockPageIfNeeded();

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      window.setTimeout(function () {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      }, 30);
    }
  }

  function closeActiveModal() {
    if (activeModal) {
      closeModal(activeModal);
    }
  }

  function trapFocus(event) {
    if (!activeDialog || event.key !== 'Tab') return;

    var focusableElements = getFocusableElements(activeDialog);

    if (!focusableElements.length) {
      event.preventDefault();
      activeDialog.focus();
      return;
    }

    var firstElement = focusableElements[0];
    var lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  function toggleAccordion(button) {
    if (!button) return;

    var accordion = button.closest('[data-ep-size-accordion]');
    if (!accordion) return;

    var panel = accordion.querySelector('[data-ep-size-accordion-panel]');
    var isOpen = accordion.classList.toggle('is-open');

    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (panel) {
      panel.hidden = !isOpen;
    }
  }

  function toggleCategoryMenu(button) {
    var category = button.closest('[data-ep-size-category]');
    if (!category) return;

    var menu = category.querySelector('[data-ep-size-category-menu]');
    if (!menu) return;

    var isOpen = menu.hidden;

    menu.hidden = !isOpen;
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function closeCategoryMenus() {
    document.querySelectorAll('[data-ep-size-category]').forEach(function (category) {
      var button = category.querySelector('[data-ep-size-category-toggle]');
      var menu = category.querySelector('[data-ep-size-category-menu]');

      if (button) button.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    });
  }

  function prepareAccordions(scope) {
    var root = scope || document;
    var accordions = root.querySelectorAll('[data-ep-size-accordion]');

    accordions.forEach(function (accordion, index) {
      var button = accordion.querySelector('[data-ep-size-accordion-button]');
      var panel = accordion.querySelector('[data-ep-size-accordion-panel]');

      if (!button || !panel) return;

      if (!panel.id) {
        panel.id = 'EpSizeAccordion-' + index + '-' + Math.random().toString(36).slice(2, 8);
      }

      button.setAttribute('aria-expanded', accordion.classList.contains('is-open') ? 'true' : 'false');
      button.setAttribute('aria-controls', panel.id);
      panel.hidden = !accordion.classList.contains('is-open');
    });
  }

  function prepareModals(scope) {
    var root = scope || document;
    var modals = root.querySelectorAll('[data-ep-size-modal]');

    modals.forEach(function (modal) {
      modal.setAttribute('aria-hidden', modal.classList.contains('is-open') ? 'false' : 'true');

      if (!modal.dataset.epCurrentChart) {
        modal.dataset.epCurrentChart = 'premium-oversize';
      }

      applyChart(modal, modal.dataset.epCurrentChart);
    });

    moveModalsToBody(root);
  }

  function initEspinaSizeChart(scope) {
    var root = scope || document;

    prepareAccordions(root);
    prepareModals(root);
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-ep-size-open]');
    var closeButton = event.target.closest('[data-ep-size-close]');
    var accordionButton = event.target.closest('[data-ep-size-accordion-button]');
    var categoryToggle = event.target.closest('[data-ep-size-category-toggle]');
    var chartSelect = event.target.closest('[data-ep-chart-select]');

    if (!event.target.closest('[data-ep-size-category]')) {
      closeCategoryMenus();
    }

    if (openButton) {
      event.preventDefault();
      openModalById(openButton.getAttribute('aria-controls'));
      return;
    }

    if (closeButton) {
      event.preventDefault();
      closeModal(closeButton.closest('[data-ep-size-modal]'));
      return;
    }

    if (categoryToggle) {
      event.preventDefault();
      toggleCategoryMenu(categoryToggle);
      return;
    }

    if (chartSelect) {
      event.preventDefault();

      var modal = chartSelect.closest('[data-ep-size-modal]');
      var handle = chartSelect.getAttribute('data-ep-chart-select');

      applyChart(modal, handle);
      closeCategoryMenus();
      return;
    }

    if (accordionButton) {
      event.preventDefault();
      toggleAccordion(accordionButton);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeCategoryMenus();
      closeActiveModal();
      return;
    }

    trapFocus(event);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initEspinaSizeChart(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initEspinaSizeChart(event.target);
  });
})();